import React, { Component } from 'react';
import { Col, Row, Input, Container } from 'reactstrap';
import CatalogItems from './components/CatalogItems';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import { withRouter } from 'react-router-dom'
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux'
import { GetProducts } from '../../../queries/products'
import { loadProducts } from '../../../redux/actions/productActions'
import qs from 'qs';
import { loader as Loader } from '../../Loader'

class Catalog extends Component {

  state = {
    search: '',
    tags: [],
    data: [],
    hasMore: null,
    nextToken: null,
    scrolledToBottom: false,
    paginationLoaded: false,
    loadingProducts: true,
    loadedProducts: false,
    query: null
  };

  handleOnScroll = () => {
    var scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    var scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    var clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    var scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (scrolledToBottom && this.state.hasMore) {
      this.setState({
        scrolledToBottom: true,
        paginationLoaded: false,
        loadingProducts: true,
        hasMore: null //prevents an extra fetchMore call, relying on the query to set this if there is more
      }, () => {
        this.fetchMore();
      })
    }
  };

  async componentDidMount () {
    const queries = qs.parse(this.props.location.search.slice(1))
    const tag = queries.tag ? queries.tag.replace(/-/g, ' ').split(',') : null

    window.addEventListener("scroll", this.handleOnScroll);

    const { data: productData } = await this.props.client.query({
      query: GetProducts(),
      fetchPolicy: 'network-only',
      variables: { nextToken: null },
    })

    //setting default state
    this.props.loadProducts(productData.listProducts.items)
    this.setState({
      data: productData.listProducts.items,
      loadedProducts: true,
      loadingProducts: false,
      nextToken: productData.listProducts.nextToken,
      hasMore: productData.listProducts.nextToken ? true : false,
      paginationLoaded: true,
      scrolledToBottom: false,
      tags: tag ? tag : [],
      search: tag ? tag : ''
    })
  }

  fetchMore = async () => {
    const { data: productData } = await this.props.client.query({
      query: GetProducts(),
      fetchPolicy: 'network-only',
      variables: { nextToken: this.state.nextToken },
    })

    if (productData.listProducts && productData.listProducts.items) {

      this.props.loadProducts([...this.state.data, ...productData.listProducts.items])
      this.setState({
        data: [...this.state.data, ...productData.listProducts.items],
        loadedProducts: true,
        loadingProducts: false,
        nextToken: productData.listProducts.nextToken,
        hasMore: productData.listProducts.nextToken ? true : false,
        paginationLoaded: true,
        scrolledToBottom: false,
        tags: this.tag ? this.tag : [],
        search: this.tag ? this.tag : ''
      })
    } else {
      this.setState({
        loadedProducts: true,
        loadingProducts: false,
        paginationLoaded: true,
        scrolledToBottom: false
      })
    }

  }

  componentWillUnmount () {
    window.removeEventListener("scroll", this.handleOnScroll);
  }

  updateSearch (event) {
    this.setState({
      search: event.target.value,
      tags: event.target.value.trim().split(' ')
    })

  }

  clearFilter (e) {
    e.preventDefault()
    window.history.pushState(null, null, window.location.pathname)
    this.setState({
      search: '',
      tags: []
    })
  }

  render () {
    let filterData = [];
    let dataSet = new Set()
    if (this.state.tags.length) {
      this.state.tags.map((q) => {
        return this.state.data.filter((item) => {
          let val = item.tags.find(c => c.toLowerCase().includes(q.toLowerCase()))

          return (val ? dataSet.add(item) : null)
        })
      })
      dataSet.forEach(data => filterData.push(data))
    }
    else if (!this.props.match.params.tag) {
      filterData = this.state.data.filter((item) => {
        return item["productName"].toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
      })
    } else {
      filterData = this.state.data;
    }

    return (
      <Container>
        {/* <Query
            query={GetProducts()}
            fetchPolicy={'network-only'}
            variables={{ nextToken: null }}
            onError={(e) => {
              if (e.networkError) {
                if (e.networkError['statusCode'] === 401) {
                  this.signoutUser()
                }
              } else {
                console.log(e.message)
              }
            }}
            onCompleted={(data) => {
              if (data && data.listProducts) {
                this.props.loadProducts(data.listProducts.items)
                this.setState({
                  data: data.listProducts.items,
                  loadedProducts: true,
                  loadingProducts: false,
                  nextToken: data.listProducts.nextToken,
                  hasMore: data.listProducts.nextToken ? true : false,
                  paginationLoaded: true,
                  scrolledToBottom: false,
                })
              } else {
                this.setState({
                  loadedProducts: true,
                  loadingProducts: false
                });
              }
            }}>
            {({ loading, error, fetchMore }) => {
              console.log(fetchMore)
              if (!loading && this.state.hasMore === true && this.state.scrolledToBottom === true) {
                fetchMore({
                  variables: {
                    nextToken: this.state.nextToken
                  },
                  updateQuery: (prev, { fetchMoreResult }) => {
                    console.log('here')
                    if (!fetchMoreResult) return prev;
                    const combinedProducts = prev.listProducts.items.concat(fetchMoreResult.listProducts.items)

                    return Object.assign({}, prev, {
                      listProducts: {
                        items: combinedProducts,
                        nextToken: fetchMoreResult.listProducts.nextToken,
                        __typename: fetchMoreResult.listProducts.__typename
                      }
                    })
                  }
                })
              }

              if (loading) return null;
              if (error) {
                console.log(`ERROR > ${error.message}`);
                return null
              }
              return null
            }}

          </Query> */}
        {this.state.data.length === 0 ? <Loader /> :
          <React.Fragment>

            <Row>
              <MagnifyIcon className="search-icon" />
              <Input
                className="search-input-field"
                value={this.state.search}
                onChange={this
                  .updateSearch
                  .bind(this)}
                placeholder="Search products by tag"
                style={{
                  float: 'right'
                }} />
              {this.state.search !== '' ? <span className='lnr lnr-cross filter-cancel-btn'
                onClick={this.clearFilter.bind(this)} />
                : null}
            </Row>
            <Row>
              <Col md={12}>
                <h3 className="page-title">{`Marketplace`} </h3>
              </Col>
            </Row>
            <Row>
              {
                filterData.length !== 0 ?
                  <CatalogItems catalog_items={filterData} />
                  :
                  <div> No Results Found </div>
              }
            </Row>
            {
              !this.state.paginationLoaded || this.state.loadingProducts ?
                <div className={`custom_load loaded`}>
                  <div className='load__icon-wrap' style={{ textAlign: 'center', margin: '30px auto' }}>
                    <svg className='load__icon'>
                      <path fill='#2d9aa6' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
                    </svg>
                  </div>
                </div>
                : null
            }
          </React.Fragment>
        }
      </Container >
    )
  }
}

function mapStateToProps (state) {
  return {
    products: state.productsData ? state.productsData.products : null,
    sidebar: state.sidebar,
    cartItems: state.cartData.items
  }
}

export default withRouter(withApollo(connect(mapStateToProps, { loadProducts })(Catalog)));


// WEBPACK FOOTER //
// ./src/components/e-commerce/catalog/Catalog.js